module.exports = [{"id":1,"author":"Confucius","text":"Choose a job you love and you will never have to work a day in your life."}]


//////////////////
// WEBPACK FOOTER
// ./src/data/quotes.json
// module id = 256
// module chunks = 0